//--------------------------------------------------------------------//
//******************** deploymentsCtrl *********************************//
//--------------------------------------------------------------------//
// Controller for the Deployments settings tab. Fetches the deployments
// list on load and provides a dialog for creating new deployments by
// picking one of the user's repositories (RepositoriesService.getList(),
// already loaded by userSettingsMod via the Repositories feature) and
// entering a single multi-line command (joined with && before submitting).
import addDeploymentDialogTemplateUrl from './add-deployment-dialog.template.html';

angular.module('userSettingsMod')

.controller('deploymentsCtrl', ['$scope', 'GhDialog', 'DeploymentsService', 'RepositoriesService', 'localizationService', '$templateCache', async function($scope, GhDialog, DeploymentsService, RepositoriesService, localizationService, $templateCache) {
  const dictionary = localizationService.getDictionary('account_settings');
  $scope.translate = (word) => localizationService.translate(word, dictionary);

  $scope.deployments = [];

  // Fetches all deployments from the server and populates the list.
  $scope.getDeployments = async function() {
    try {
      $scope.deployments = await DeploymentsService.getList();
      $scope.$evalAsync();
    } catch (error) {
      console.log(error);
    }
  };

  // Opens the "Add Deployment" dialog: repo picker, command, active toggle.
  $scope.showDialog = function() {
    GhDialog.show({
      position: 'center',
      toolbar: false,
      locals: {
        deployments: $scope.deployments,
        safeApply: () => $scope.$evalAsync()
      },
      template: {
        toolbar: '',
        resizable: false,
        content: $templateCache.get(addDeploymentDialogTemplateUrl)
      },
      controller: ['$scope', 'deployments', 'safeApply', 'DeploymentsService', 'RepositoriesService', 'localizationService', async function($scope, deployments, safeApply, DeploymentsService, RepositoriesService, localizationService) {
        const dictionary = localizationService.getDictionary('account_settings');
        $scope.translate = (word) => localizationService.translate(word, dictionary);
        $scope.errMessage = '';
        $scope.loadingRepos = true;
        $scope.repoOptions = [];

        $scope.deployment = {
          repo_id: null,
          command: 'npm run build\nnpm run start',
          active: 1
        };
        $scope.isCreating = false;

        // Only repos with a computed git_clone URL can be deployed — that URL
        // is what the deployment-manager clones over SSH.
        try {
          const repos = await RepositoriesService.getList();
          $scope.repoOptions = (Array.isArray(repos) ? repos : []).filter((repo) => !!repo.git_clone);
        } catch (error) {
          console.log('Failed to load repositories:', error);
        } finally {
          $scope.loadingRepos = false;
          $scope.$evalAsync();
        }

        $scope.addDeployment = async function() {
          if (!$scope.deployment.repo_id) {
            $scope.errMessage = 'Please, select a repository';
            return;
          }

          const repo = $scope.repoOptions.find((r) => r._id === $scope.deployment.repo_id);
          if (!repo) {
            $scope.errMessage = 'Selected repository is no longer available';
            return;
          }

          $scope.isCreating = true;

          try {
            const created = await DeploymentsService.create({
              repo_url: repo.git_clone,
              run_command: DeploymentsService.joinCommandLines($scope.deployment.command),
              active: $scope.deployment.active ? 1 : 0
            });
            deployments.push(created);
            safeApply();
            $scope.cancel();
          } catch (error) {
            console.log(error);
            $scope.errMessage = error.message || 'Something went wrong. Please, try again';
            $scope.isCreating = false;
            $scope.$evalAsync();
          }
        };
      }]
    });
  };

  await $scope.getDeployments();

}]);
